import { useGetFileBlobSrc } from '@/hooks/use-get-file-src.hook';
import { useGetOrganizationProfilePicture } from '@/modules/Organizations/queries/get-organization-profile-picture';
import { AvatarSize, UserAvatar } from '..';

type OrganizationAvatarProps = {
  organizationId: number;
  name: string;
  size: AvatarSize;
  hasImage: boolean;
  allowEdit?: boolean;
  onUploadClick?: (file: File) => void;
  onDeleteClick?: () => void;
  isLoading?: boolean;
  imageId?: number;
};

export const OrganizationAvatar = ({
  size,
  organizationId,
  name,
  hasImage,
  allowEdit,
  onUploadClick,
  onDeleteClick,
  isLoading,
  imageId,
}: OrganizationAvatarProps) => {
  const { data: image, isLoading: isLoadingFile } =
    useGetOrganizationProfilePicture(organizationId, hasImage);
  const profilePictureUrl = useGetFileBlobSrc(image);

  return (
    <UserAvatar
      isLoading={(isLoading || isLoadingFile) && hasImage}
      imageSrc={profilePictureUrl}
      name={name}
      size={size}
      allowEdit={allowEdit}
      onUploadClick={onUploadClick}
      onDeleteClick={onDeleteClick}
      imageId={imageId}
      fetchImage={false}
    />
  );
};
